import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { DistanceFormat } from '@paragon/contract-library';

interface ApplicationState {
  readonly distanceFormat: DistanceFormat;
}

const initialState: ApplicationState = {
  distanceFormat: 'Architectural',
};

const applicationSlice = createSlice({
  name: 'application',
  initialState,
  reducers: {
    setDistanceFormat: (state, action: PayloadAction<DistanceFormat>) => {
      state.distanceFormat = action.payload;
    },
  },
});

export const { setDistanceFormat } = applicationSlice.actions;
export const application = applicationSlice.reducer;
